module.exports = __webpack_public_path__ + "media/images/price_list/feature-3-067f1e418cdcaeb1447062231405387b.webp";